import React from 'react';

import { TextField, useRecordContext } from 'react-admin';

import { get, isEmpty, keyBy } from 'lodash';

import { Typography } from '@mui/material';

import Answer from '../Answer';

import { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import { ProductsParameters } from '../../questionParameters';

const ValueField = ({
  extraParameters,
}: {
  extraParameters?: ProductsParameters;
  language?: Languages;
}) => {
  const record = useRecordContext();

  const values = get(record, 'value.options');
  const sx = get(record, 'sx', {});

  if (isEmpty(values)) return <Typography>-</Typography>;

  const mapFields = keyBy(
    extraParameters?.options?.map((option) => ({
      id: option.id,
      name: extraParameters.choiceLabels?.[option.id] ?? option.label,
    })),
    'id',
  );

  const value = values.map((v: string) => get(mapFields, v, { name: v }).name).join(', ');

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const Products = ({
  extraParameters,
}: {
  extraParameters?: ProductsParameters;
}) => (
  <Answer
    datapoint={conflictFields.PRODUCTS}
    identificationInfo={undefined}
    label={extraParameters?.label ?? ''}
    source="products"
  >
    <ValueField extraParameters={extraParameters} />
  </Answer>
);

Products.ValueField = ValueField;

export default Products;
